import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const MergeSort = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Merge Sort"
    videos={[
      "https://www.youtube.com/embed/mB5HXBb_HY8"
    ]}
    takeaways={[]}
    questions={[
      "Imagine we have two sorted lists with no common elements. Suppose we need to search for an element to see whether it is present in either of the lists. Write an efficient algorithm for this and analyze the time complexity of your algorithm.",
      "Sort the following numbers 3,1,4,8,5,9,2,6 using sorting algorithm based on breaking down a list into sub-lists until each sub list consists of a single element and combine those sub lists in a manner that results into a sorted list. And determine the running time of the algorithm for: a. Sorted input b. Reverse-ordered input c. Random input"
    ]}
    exampleVideos={[]}
  />
);
}

export default MergeSort;
